/**
 * /tenants/$slug/authentication/sign-in/sessions — how long people and admins
 * stay signed in.
 */

import { createFileRoute } from "@tanstack/react-router";
import { SessionsSection } from "@/features/signin-settings/pages/sessions-section";

export const Route = createFileRoute("/_authed/tenants/$slug/authentication/sign-in/sessions")({
  component: SessionsSection,
});
